const FETCH_STATUS = {
    none: 'none',
    fetching: 'fetching',
    done: 'done',
};


export default function createFetchOnce<T>(originFetch: (data: any) => Promise<T>) {
    let fetchStatus = FETCH_STATUS.none;
    let fetch: Promise<T> | null = null;
    let resCache: T | null = null;
    return (data: any) => {
        if (fetchStatus === FETCH_STATUS.fetching) {
            return fetch as Promise<T>;
        }
        if (fetchStatus === FETCH_STATUS.done) {
            return Promise.resolve(resCache);
        }
        fetch = new Promise((rs, rj) => {
            fetchStatus = FETCH_STATUS.fetching;
            originFetch(data).then((res) => {
                fetchStatus = FETCH_STATUS.done;
                resCache = res;
                rs(res);
            }).catch((e) => {
                console.error(e);
                fetchStatus = FETCH_STATUS.done;
                rj();
            });
        });
        return fetch;
    };
}
